// import React, { useEffect, useState } from 'react'
// import ProductVariantsModal from '../components/ProductVariantsModal';
// import apiCall from '../helper/apiCall';

// const Product = () => {
//   const [products, setProducts] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [statusFilter, setStatusFilter] = useState('All');
//     const [searchQuery, setSearchQuery] = useState('');
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [message, setMessage] = useState(null);

//     // Fetch products based on filters
//     useEffect(() => {
//         const fetchProducts = async () => {
//             setLoading(true);
//             const response = await apiCall("getProducts", { statusFilter, searchQuery });
//             if (response?.success) {
//                 setProducts(response.data);
//             }
//             setLoading(false);
//         };
//         fetchProducts();
//     }, [statusFilter, searchQuery, message]);

//     const handleViewClick = (product) => {
//         setSelectedProduct(product);
//         setIsModalOpen(true);
//     };

//     const handleCloseModal = () => {
//         setIsModalOpen(false);
//         setSelectedProduct(null);
//         // Refresh products after modal closes to show any status changes
//         // This is a simple way to trigger a re-fetch without complex state management.
//         setStatusFilter(prev => prev);
//     };

//     const handleSaveMessage = (msg, isError = false) => {
//         setMessage({ text: msg, isError });
//         setTimeout(() => setMessage(null), 3000);
//     };

//     return (
//         <div className="font-sans antialiased text-gray-900 bg-gray-50 min-h-screen p-4 sm:p-8">
//             <div className="max-w-7xl mx-auto">
//                 <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
//                     <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-800">Product Management</h1>
//                     <div className="w-full md:w-fit">
//                         <input
//                             type="text"
//                             placeholder="Search by product name..."
//                             value={searchQuery}
//                             onChange={(e) => setSearchQuery(e.target.value)}
//                             className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 shadow-sm text-sm"
//                         />
//                     </div>
//                 </div>

//                 {message && (
//                     <div className={`mb-4 px-4 py-3 rounded-lg text-center font-medium ${message.isError ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
//                         {message.text}
//                     </div>
//                 )}

//                 <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 mb-6">
//                     <h3 className="text-sm font-semibold text-gray-600 mb-2">Status Filter</h3>
//                     <div className="flex flex-wrap gap-2">
//                         {['All', 'Active', 'Inactive'].map(status => (
//                             <button
//                                 key={status}
//                                 onClick={() => setStatusFilter(status)}
//                                 className={`px-3 py-1 rounded-full text-xs font-medium transition-colors duration-200 ${statusFilter === status
//                                     ? 'bg-blue-600 text-white shadow-sm'
//                                     : 'bg-gray-100 text-gray-700 hover:bg-blue-100 hover:text-blue-700'
//                                 }`}
//                             >
//                                 {status}
//                             </button>
//                         ))}
//                     </div>
//                 </div>

//                 {loading ? (
//                     <div className="text-center py-8 text-gray-500">Loading products...</div>
//                 ) : products.length === 0 ? (
//                     <div className="text-center py-8 text-gray-500">No products found matching your criteria.</div>
//                 ) : (
//                     <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
//                         <div className="overflow-x-auto">
//                             <table className="min-w-full divide-y divide-gray-200">
//                                 <thead className="bg-gray-50">
//                                     <tr>
//                                         <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product Name</th>
//                                         <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
//                                         <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                                         <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody className="bg-white divide-y divide-gray-200">
//                                     {products.map(product => (
//                                         <tr key={product.product_id} className="hover:bg-gray-50">
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{product.product_name}</td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{product.category_name}</td>
//                                             <td className="px-6 py-4 whitespace-nowrap">
//                                                 <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${product.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
//                                                     {product.status}
//                                                 </span>
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
//                                                 <button
//                                                     onClick={() => handleViewClick(product)}
//                                                     className="text-blue-600 hover:text-blue-900 transition-colors"
//                                                 >
//                                                     View Variants
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 )}
//             </div>
            
//             <ProductVariantsModal
//                 show={isModalOpen}
//                 onClose={handleCloseModal}
//                 product={selectedProduct}
//                 onSave={handleSaveMessage}
//             />
//         </div>
//     );
// }

// export default Product

// import React, { useEffect, useState, useRef } from 'react'
// import ProductVariantsModal from '../components/ProductVariantsModal';
// import apiCall from '../helper/apiCall';

// const Product = () => {
//   const [products, setProducts] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [statusFilter, setStatusFilter] = useState('All');
//     const [searchQuery, setSearchQuery] = useState('');
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [message, setMessage] = useState(null);

//     const inputRef = useRef(null);

//     // Optimized: Removed searchQuery from dependencies to prevent excessive calls
//     const fetchProducts = async () => {
//         setLoading(true);
//         const response = await apiCall("getProducts", { statusFilter, searchQuery });
//         if (response?.success) {
//             setProducts(response.data);
//         }
//         setLoading(false);
//     };

//     // Only triggers on initial load, status change, or success message
//     useEffect(() => {
//         fetchProducts();
//     }, [statusFilter, message]);

//     useEffect(() => {
//         if (inputRef.current) {
//             inputRef.current.focus();
//         }
//     }, []);

//     const handleKeyDown = (e) => {
//         if (e.key === 'Enter') {
//             fetchProducts(); // Manually trigger search on Enter (Scanner finish)
//         }
//     };

//     const handleViewClick = (product) => {
//         setSelectedProduct(product);
//         setIsModalOpen(true);
//     };

//     const handleCloseModal = () => {
//         setIsModalOpen(false);
//         setSelectedProduct(null);
//         setStatusFilter(prev => prev);
//     };

//     const handleSaveMessage = (msg, isError = false) => {
//         setMessage({ text: msg, isError });
//         setTimeout(() => setMessage(null), 3000);
//     };

//     return (
//         <div className="font-sans antialiased text-gray-900 bg-gray-50 min-h-screen p-4 sm:p-8">
//             <div className="max-w-7xl mx-auto">
//                 <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
//                     <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-800">Product Management</h1>
//                     <div className="w-full md:w-fit">
//                         <input
//                             ref={inputRef}
//                             type="text"
//                             placeholder="Scan Barcode & Press Enter..."
//                             value={searchQuery}
//                             onChange={(e) => setSearchQuery(e.target.value)}
//                             onKeyDown={handleKeyDown}
//                             className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-200 shadow-sm text-sm"
//                         />
//                     </div>
//                 </div>

//                 {message && (
//                     <div className={`mb-4 px-4 py-3 rounded-lg text-center font-medium ${message.isError ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
//                         {message.text}
//                     </div>
//                 )}

//                 <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 mb-6">
//                     <h3 className="text-sm font-semibold text-gray-600 mb-2">Status Filter</h3>
//                     <div className="flex flex-wrap gap-2">
//                         {['All', 'Active', 'Inactive'].map(status => (
//                             <button
//                                 key={status}
//                                 onClick={() => setStatusFilter(status)}
//                                 className={`px-3 py-1 rounded-full text-xs font-medium transition-colors duration-200 ${statusFilter === status
//                                     ? 'bg-blue-600 text-white shadow-sm'
//                                     : 'bg-gray-100 text-gray-700 hover:bg-blue-100 hover:text-blue-700'
//                                 }`}
//                             >
//                                 {status}
//                             </button>
//                         ))}
//                     </div>
//                 </div>

//                 {loading ? (
//                     <div className="text-center py-8 text-gray-500">Loading products...</div>
//                 ) : products.length === 0 ? (
//                     <div className="text-center py-8 text-gray-500">No products found.</div>
//                 ) : (
//                     <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
//                         <div className="overflow-x-auto">
//                             <table className="min-w-full divide-y divide-gray-200">
//                                 <thead className="bg-gray-50">
//                                     <tr>
//                                         <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product Name</th>
//                                         <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
//                                         <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                                         <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody className="bg-white divide-y divide-gray-200">
//                                     {products.map(product => (
//                                         <tr key={product.product_id} className="hover:bg-gray-50">
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{product.product_name}</td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{product.category_name}</td>
//                                             <td className="px-6 py-4 whitespace-nowrap">
//                                                 <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${product.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
//                                                     {product.status}
//                                                 </span>
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
//                                                 <button
//                                                     onClick={() => handleViewClick(product)}
//                                                     className="text-blue-600 hover:text-blue-900 transition-colors"
//                                                 >
//                                                     View Variants
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 )}
//             </div>
            
//             <ProductVariantsModal
//                 show={isModalOpen}
//                 onClose={handleCloseModal}
//                 product={selectedProduct}
//                 onSave={handleSaveMessage}
//             />
//         </div>
//     );
// }

// export default Product

import React, { useEffect, useState, useRef } from 'react';
import ProductVariantsModal from '../components/ProductVariantsModal';
import apiCall from '../helper/apiCall';
import { FiSearch, FiBox, FiRefreshCw, FiEye, FiCheckCircle, FiXCircle } from 'react-icons/fi'; // Suggested icons

const Product = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statusFilter, setStatusFilter] = useState('All');
    const [searchQuery, setSearchQuery] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [message, setMessage] = useState(null);

    const inputRef = useRef(null);

    const fetchProducts = async () => {
        setLoading(true);
        try {
            const response = await apiCall("getProducts", { statusFilter, searchQuery });
            if (response?.success) {
                setProducts(response.data);
            }
        } catch (err) {
            handleSaveMessage("Failed to fetch products", true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, [statusFilter, message]);

    useEffect(() => {
        if (inputRef.current) inputRef.current.focus();
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') fetchProducts();
    };

    const handleViewClick = (product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    };

    const handleSaveMessage = (msg, isError = false) => {
        setMessage({ text: msg, isError });
        setTimeout(() => setMessage(null), 3000);
    };

    return (
        <div className="min-h-screen bg-[#f8fafc] p-4 md:p-8 font-sans">
            <div className="max-w-7xl mx-auto">
                
                {/* Header Section */}
                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6 mb-8">
                    <div>
                        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
                            <FiBox className="text-blue-600" /> Product Inventory
                        </h1>
                        <p className="text-slate-500 text-sm mt-1">Manage your variants, stock levels, and product visibility.</p>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
                        <div className="relative flex-grow">
                            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                            <input
                                ref={inputRef}
                                type="text"
                                placeholder="Scan or search products..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onKeyDown={handleKeyDown}
                                className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all outline-none shadow-sm"
                            />
                        </div>
                        <button 
                            onClick={fetchProducts}
                            className="inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-white border border-slate-200 text-slate-700 rounded-xl hover:bg-slate-50 transition-colors font-medium shadow-sm"
                        >
                            <FiRefreshCw className={`${loading ? 'animate-spin' : ''}`} />
                            <span className="sm:hidden lg:inline">Refresh</span>
                        </button>
                    </div>
                </div>

                {/* Toast Message */}
                {message && (
                    <div className={`fixed top-5 right-5 z-50 px-6 py-3 rounded-2xl shadow-2xl border animate-bounce ${
                        message.isError ? 'bg-red-50 border-red-100 text-red-700' : 'bg-emerald-50 border-emerald-100 text-emerald-700'
                    }`}>
                        {message.text}
                    </div>
                )}

                {/* Filters & Content */}
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                    <div className="p-4 border-b border-slate-100 bg-slate-50/50 flex items-center justify-between">
                        <div className="flex bg-slate-200/50 p-1 rounded-lg">
                            {['All', 'Active', 'Inactive'].map(status => (
                                <button
                                    key={status}
                                    onClick={() => setStatusFilter(status)}
                                    className={`px-4 py-1.5 rounded-md text-sm font-semibold transition-all ${
                                        statusFilter === status 
                                        ? 'bg-white text-blue-600 shadow-sm' 
                                        : 'text-slate-600 hover:text-slate-900'
                                    }`}
                                >
                                    {status}
                                </button>
                            ))}
                        </div>
                        <span className="text-xs font-bold text-slate-400 uppercase tracking-wider">
                            Showing {products.length} Products
                        </span>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-left border-collapse">
                            <thead>
                                <tr className="text-slate-400 text-[11px] uppercase tracking-widest font-bold">
                                    <th className="px-6 py-4">Product Info</th>
                                    <th className="px-6 py-4">Category</th>
                                    <th className="px-6 py-4 text-center">Status</th>
                                    <th className="px-6 py-4 text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {loading ? (
                                    <tr>
                                        <td colSpan="4" className="px-6 py-12 text-center">
                                            <div className="flex flex-col items-center gap-2">
                                                <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                                <p className="text-slate-500 text-sm font-medium">Updating list...</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : products.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="px-6 py-20 text-center text-slate-400">
                                            No products match your criteria.
                                        </td>
                                    </tr>
                                ) : (
                                    products.map(product => (
                                        <tr key={product.product_id} className="hover:bg-slate-50/80 transition-colors group">
                                            <td className="px-6 py-4">
                                                <div className="font-semibold text-slate-800">{product.product_name}</div>
                                                <div className="text-xs text-slate-400 mt-0.5">ID: #{product.product_id}</div>
                                            </td>
                                            <td className="px-6 py-4">
                                                <span className="px-2.5 py-1 rounded-md bg-slate-100 text-slate-600 text-xs font-medium">
                                                    {product.category_name}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="flex justify-center">
                                                    {product.status === 'Active' ? (
                                                        <div className="flex items-center gap-1.5 text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full text-xs font-bold">
                                                            <FiCheckCircle /> Active
                                                        </div>
                                                    ) : (
                                                        <div className="flex items-center gap-1.5 text-red-500 bg-red-50 px-2 py-1 rounded-full text-xs font-bold">
                                                            <FiXCircle /> Inactive
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 text-right">
                                                <button
                                                    onClick={() => handleViewClick(product)}
                                                    className="inline-flex items-center gap-2 text-blue-600 bg-blue-50 hover:bg-blue-600 hover:text-white px-4 py-2 rounded-lg text-sm font-bold transition-all"
                                                >
                                                    <FiEye size={16} />
                                                    View Variants
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <ProductVariantsModal
                show={isModalOpen}
                onClose={handleCloseModal}
                product={selectedProduct}
                onSave={handleSaveMessage}
            />
        </div>
    );
}

export default Product;